import { useState } from 'react';
import { getConsent, setConsent } from '../lib/consent';

interface Props {
  onAccept: () => void;
}

export default function CookieConsent({ onAccept }: Props) {
  const [visible, setVisible] = useState(() => getConsent() === 'pending');

  if (!visible) return null;

  const accept = () => {
    setConsent('granted');
    setVisible(false);
    onAccept();
  };

  const deny = () => {
    setConsent('denied');
    setVisible(false);
  };

  return (
    <div className="c-cookie-consent">
      <p className="c-cookie-consent__text">
        当サイトではサービス向上・広告効果測定のためCookieを使用しています。
        <a
          href="https://pichipichi.co.jp/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="c-cookie-consent__link"
        >
          プライバシーポリシー
        </a>
      </p>
      <div className="c-cookie-consent__actions">
        <button className="c-cookie-consent__btn c-cookie-consent__btn--accept" onClick={accept}>
          同意する
        </button>
        <button className="c-cookie-consent__btn c-cookie-consent__btn--deny" onClick={deny}>
          拒否
        </button>
      </div>
    </div>
  );
}
